export default __webpack_public_path__ + "static/media/icon_pp_download.deb28d62.svg";